import React, { useEffect, useState, useRef } from 'react';
import { useFormik } from 'formik';
import { useLocation, useSearchParams } from 'react-router-dom';
import { Link } from "react-router-dom";

import axios from "axios"

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { PickList } from 'primereact/picklist';
import { useNavigate } from "react-router-dom";
import { DateFormatter } from "../../utils/DateFormatter";


// Autocomplete form in the ConfirmDialog
import { AutoComplete } from "primereact/autocomplete";
import DeletionDialog from '../../components/DeletionDialog';





// function renderJsonToHtml(jsonObject) {
//     return (
//       <ul>
//         {Object.keys(jsonObject).map((key) => (
//           <li key={key}>
//             <strong>{key}:</strong>
//             {typeof jsonObject[key] === 'object'
//               ? renderJsonToHtml(jsonObject[key])
//               : jsonObject[key]}
//           </li>
//         ))}
//       </ul>
//     );
//   }

export const DataSetDetails = (props) => {

    const location = useLocation();
    const [name, setName] = useState(null);
    const [datasetId, setDatasetId] = useState(null);
    const [data, setData] = useState({});
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false)
    const [deleteVisible, setDeleteVisible] = useState(false);

    const [attributes, setAttributes] = useState([]);
    const [groups, setGroups] = useState([]);
    const [samples, setSamples] = useState([]);

    const navigate = useNavigate(); 

    // const [addAttribute, setAddAttribute] = useState(false);
    const [addGroup, setAddGroup] = useState(false);
    // const [addSample, setAddSample] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars

    const getDataUserId    = JSON.parse(sessionStorage.getItem('userid'));
    const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));
    const groupIds         = JSON.parse(sessionStorage.getItem('usergroups'));


    const [refreshState, setRefreshState] = useState(true);
    let refresh = true;

    useEffect(() => {
        if (searchParams.has('datasetid')) {
            setDatasetId(searchParams.get('datasetid'));
        } else if (location.state && location.state.id !== ''){
            setDatasetId(location.state.id);
        } else {
            setDatasetId(null);  
        }

        if (location.state && location.state.name !== ''){
            setName(location.state.name);
        }

    }, [searchParams, location.state]);

    // useEffect(() => {
    //     if (location.state){
    //         setName(location.state.name);
    //     }
    // }, [location.state]);

    // useEffect(() => {
    //     if (location.state){
    //         setDatasetId(location.state.id);
    //     }
    // }, [location.state]);

    useEffect(() => {
        document.title = `Data -> Data Set Details | Palmona Pathogenomics`
    }, []);


    const toast = useRef(null);

    const accept = () => {
        toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    };

    const reject = () => {
        toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    };

    const [value, setValue] = useState('');
    const [items, setItems] = useState([]);


    const search = (event) => {
      setItems([...Array(10).keys()].map(item => event.query + '-' + item));
    }

    // useEffect(() => {
    //     if (value.length !== 0) {
    //         console.log('Value', value);
    //     }
    // }, [value]);

    const showTemplate = () => {
      confirmDialog({
          group: 'templating',
          header: 'Add Group',
          message: (
              <div className="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
                  <i className="pi pi-exclamation-circle text-6xl text-primary-500"></i>
                  <span>Please enter a group number to add to the Dataset.</span>
                  {/* <div className="card flex justify-content-center"> */}
                  <div>
                    {/* <AutoComplete value={value} suggestions={items} completeMethod={search} onChange={(e) => setValue(e.value)} /> */}
                </div>
              </div>
          ),
          accept,
          reject
      });
  };

    useEffect(() => {
        if (error) {
            console.log('Error', error);
        }
    }, [error]);

    useEffect(() => {
        if (loading) {
            console.log('Loading', loading);
        }
    }, [loading]);


    // // Add an Attribute to the Dataset
    // useEffect(() => {
    //     if (addAttribute) {
    //         console.log('Add Attribute', addAttribute);
    //     }
    //     setAddAttribute(false);
    // }, [addAttribute]);


    const show = () => {
        toast.current.show({ severity: 'success', summary: 'Adding Sample Attribute', detail: `${formik.values.name}: ${formik.values.value}`});
    };

// Formik
    const formik = useFormik({
        initialValues: {
            name: '',
            value: ''
        },
        validate: (data) => {
            let errors = {};

            if (!data.name) {
                errors.value = 'Name - Name is required.';
            }

            if (!data.value) {
                errors.value = 'Value - Value is required.';
            }

            return errors;
        },
        onSubmit: (data) => {
            data && show(data);

            postOneAttribute(data.name, data.value);
            // formik.setSubmitting(false);
            formik.resetForm();
        }
    });

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldInvalid(name) ? <small className="p-error">{formik.errors[name]}</small> : <small className="p-error">&nbsp;</small>;
    };    


    const postOneAttribute = async (name, value) => {

        const groupIds = JSON.parse(sessionStorage.getItem('usergroups'));
        const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));
        const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

        const formData = new FormData();
        formData.append('ownerId'  , getDataUserId);
        formData.append('datasetId' , datasetId);
        formData.append('groupId'  , groupIds);
        formData.append('name'     , name);
        formData.append('value'    , value);

        try {
          const response = await axios.post(
            `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/dataset_attribute`, formData,
            {
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${getDataUserToken}`,
              }
            }
          );

            const data = response.data;
            const status = response.status;
          // if (data === ) {
            //   setData(response.data);
              setError(null);
          // }

          setRefreshState(true);
          refresh = true;
        } catch (err) {
          setError(err.message);
          setData(null);
        } finally {
            setLoading(false);
            setRefreshState(true);
            refresh = true;
        }
      };



    // Add an Attribute to the Dataset

    useEffect(() => {
        if (addGroup) {
            console.log('Add Group', addGroup);
            console.log('Value', value);
        }
        setAddGroup(false);
    }, [addGroup]);

    // useEffect(() => {
    //     if (addSample) {
    //         console.log('Add Sample', addSample);
    //     }
    //     setAddSample(false);
    // }, [addSample]);
            

    useEffect(() => {
        setLoading(true);
        
        if (refresh || refreshState) {

            setRefreshState(false);
            refresh = false;


            let datasetIdLoc = null;

            if (datasetId) {
                datasetIdLoc =datasetId;
            } else if (location.state) {
                datasetIdLoc = location.state.id;
            } else {
                datasetIdLoc = null;
            }

            const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));
            const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

            const getData = async () => {
            try {
                const response = await axios.get(
                `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/dataset/${datasetIdLoc}?userId=${getDataUserId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${getDataUserToken}`,
                    }
                }
                );

                // console.log('response', response);

                setAttributes(response.data.datasetattributes);
                setGroups(response.data.datasetgroups);
                setSamples(response.data.samples);

                if (response.data) {
                    setData(response.data);
                    setError(null);
                } else {
                    setData(null);
                    setError('No Data Found');
                }
            } catch (err) {
                setError(err.message);
                setData(null);
            } finally {
                setLoading(false);
            }
            };

            if (datasetIdLoc) getData(); 

        }
    }, [datasetId, location.state, refreshState, refresh]);

    let data_object = { 
        name: 'No Data Found', 
        createdByUsername: 'No Data Found', 
        updatedAt: 'No Data Found', 
        lastAggregation: 'No Data Found', 
        is_public: 'No Data Found', 
        isDeleted: 'No Data Found'
    };

    // useEffect(() => {
    //     if (data) {
    //         console.log('Data', data);
    //         data_object.name = data.name;
    //         data_object.createdByUsername = data.createdByUsername;
    //     } 
    // }, [data]);


    // PickList
    const [source, setSource] = useState([]);
    const [target, setTarget] = useState([]);

    useEffect(() => {
        // Get the Files for the PickList
        const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));
        const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

        const getData = async () => {
        try {
            const response = await axios.get(
            `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/sample?userId=${getDataUserId}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${getDataUserToken}`,
                }
            }
            );

            setSource(response.data);
            setError(null);

        } catch (err) {
            setError(err.message);
            setSource(null);
        } finally {
            setLoading(false);
        }
        };
        getData();

    }, []);

    const itemTemplate = (item) => {
        return (
            <div className="flex flex-wrap p-2 align-items-center gap-3">
                {/* <img className="w-4rem shadow-2 flex-shrink-0 border-round" src={`https://primefaces.org/cdn/primereact/images/product/${item.image}`} alt={item.name} /> */}
                <div className="flex-1 flex flex-column gap-2">
                    <span className="font-bold">{item.name}</span>
                    <div className="flex align-items-center gap-2">
                        <i className="pi pi-file text-sm"></i>
                        <span>{item.category}</span>
                    </div>
                </div>
                {/* <span className="font-bold text-900">${item.price}</span> */}
            </div>
        );
    };


    const onChange = (event) => {
        setSource(event.source);
        setTarget(event.target);
    };

    const addSamples = () => {
        const groupIds = JSON.parse(sessionStorage.getItem('usergroups'));
        const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));
        const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

        Promise.all(target.map((sample) => {

            const formData = new FormData();
            formData.append('sampleId'  , sample.id);
            formData.append('userId'    , getDataUserId);


            return fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/dataset/${datasetId}`,
                {
                    method: 'PATCH',
                    headers: {
                        Authorization: `Bearer ${getDataUserToken}`,
                    },
                    body: formData
                }
            ).then(res => res.json());
        }))
            .then(samples => {
                // show toast with num of samples
                toast.current.show({
                    severity:'success',
                    summary: 'Success', 
                    content: () => (
                        <div className="flex flex-column align-items-left" style={{ flex: '1' }}>
                            <div className="flex flex-column align-items-center gap-2">
                                <div className="font-bold text-900">Added {samples.length} sample{samples.length > 1 ? 's' : ''} to the dataset.</div>
                                <div className="font-bold text-900">Dataset has been saved.</div>
                            </div>
                        </div>
                    ), 
                    life: 10000});
                setError(null);
                setLoading(false);
                setRefreshState(true);
                refresh = true;
            })
        setTarget([]);

    };

    // End of PickList


    const [navToWorkflow, setNavToWorkflow] = useState(false);

    useEffect(() => {
        if (navToWorkflow) {
            const path = "/workflows/select" ;
            // console.log('path', path);
            navigate(path,{
                state:{
                    id:datasetId,
                    dataSet: data
                }
            });
        }
    }, [navToWorkflow]);

    const isAnyDeletedSamples = () => {
        let isDeleted = false;
        samples.forEach(file => {
            if (file.isDeleted) {
                isDeleted = true;
            }
        });
        return isDeleted;
    }


    const nameBodyTemplate = (sample) => {
        const notDeletedClass = 'pi pi-exclamation-triangle text-danger';
        const deletedClass = 'pi pi-check-circle text-success';
        const sampleIsDeleted = Boolean(sample?.isDeleted) || false;

        return (
            <div className="flex align-items-center gap-3">
                <i className={ !sampleIsDeleted ? deletedClass : notDeletedClass} />
                <Link to={`/datasets/sample_details?sampleid=${sample.id}`}>{sample.name}</Link>
            </div>
        );
    };

    const dateTemplate = (sample, prop) => DateFormatter(sample[prop]);

    const deleteDataset = async (datasetId) => {
        const userId = JSON.parse(sessionStorage.getItem('userid'));
        try {

          const method = 'PUT';

          const body = new FormData();
          body.append("isDeleted", true);
          body.append("userId", userId);
          

          const headers = {
            'Authorization': `Bearer ${getDataUserToken}`,
          }

          fetch(process.env.REACT_APP_WORKFLOW_API_PATH + `wfapi/dataset/${datasetId}`,
          {
            method,
            headers,
            body
          })
                .then(res => {
                    // console.log('res', res);
                    if (res.ok) {
                        navigate("/datasets/#");
                    }
                })
        }
        catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }    

    const unDeleteDataset = async (datasetId) => {
        const userId = JSON.parse(sessionStorage.getItem('userid'));
        try {

          const method = 'PUT';

          const body = new FormData();
          body.append("isDeleted", false);
          body.append("userId", userId);

          const headers = {
            'Authorization': `Bearer ${getDataUserToken}`,
          }

          fetch(process.env.REACT_APP_WORKFLOW_API_PATH + `wfapi/dataset/${datasetId}`,
          {
            method,
            headers,
            body
          })
                .then(res => {
                    // console.log('res', res);
                    if (res.ok) {
                        window.location.reload();
                    }
                })
        }
        catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }

    const datasetIsDeleted = data?.isDeleted ? 'Deleted' : 'Not Deleted';
    const data_is_public = data?.is_public || false;

    useEffect(() => {
        window.scrollTo(0, 0);
        }, []);


    const renderSampleFooter = () => {

        const loc_isDeleted = data?.isDeleted || false;

        if (loc_isDeleted) {
            return (
                null
            ); 
        } else {
            return (
                <Button onClick={() => removeSamples()} label="Remove Selected Samples from Dataset" className="w-auto mt-3" tooltip='Remove Samples from this Dataset.'/> 
            );
        }
    };

    const sampleFooter = renderSampleFooter();   
    const [selectedSamples, setSelectedSamples] = useState(null);
    const [rowClick, setRowClick] = useState(true);

    const removeSamples = () => {
        // const groupIds = JSON.parse(sessionStorage.getItem('usergroups'));
        // const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));
        const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

        Promise.all(selectedSamples.map((sample) => {

            const formData = new FormData();
            formData.append('sampleId'    , sample.id);

            return fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/dataset/${datasetId}/sample/${sample.id}`,
                {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${getDataUserToken}`,
                    },
                    body: formData
                }
            ).then(res => res.json());
        }))
            .then(samples => {
                toast.current.show({severity:'success', summary: 'Success', detail:`Removed ${samples.length} sample${samples.length > 1 ? 's' : ''} from the dataset.`, life: 10000});
                setError(null);
                setLoading(false);
                setRefreshState(true);
                refresh = true;
            })
        setSelectedSamples([]);

    };

    return (
        <>  
      <div className="surface-card p-4 shadow-2 border-round">
        <Toast ref={toast} position='center'/>
        <ConfirmDialog group="templating" />
        <div className="flex justify-content-between align-items-center mb-5">
            <div className="align-items-center gap-3">
                <div className="font-medium text-3xl text-900 mb-3">Dataset Details</div>
                <p className="text-500 mb-5">Details for the dataset {datasetId}: {data?.name ? data.name : 'Dataset Not Found'}</p>
            </div>
            { data?.isDeleted || isAnyDeletedSamples() || !data ? null :
                <div className="flex align-items-center gap-3">
                    <Button label='Create Workflow From Dataset' onClick={() => setNavToWorkflow(true)} />
                </div>
            }
        </div>

        { isAnyDeletedSamples() ?
                <div className="flex justify-content text-danger" tooltip='Samples which have been deleted can not be removed from the Sample.'> This Dataset containes deleted Samples. </div>
                :
                null
        }

      {/* <div className="text-500 mb-5">Morbi tristique blandit turpis. In viverra ligula id nulla hendrerit rutrum.</div> */}
      <ul className="list-none p-0 m-0">
          <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Name</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data?.name ? data.name : 'Name Unknown'}</div>
          </li>
          <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Created By</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data?.createdByUsername ? data?.createdByUsername : 'Username Unknown '}</div>
          </li>
          <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Last Updated</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data?.updatedAt ? data.updatedAt : 'Updated Date Unknown'}</div>
          </li>
          <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Last Aggregated</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data?.lastAggregation ? data.lastAggregation : 'Aggretation Date Unknown'}</div>
          </li>

          { !data ? null :
          <>
          <li className="flex align-items-center py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Privacy</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{data?.is_public ? 'Public' : 'Private'}</div>
          </li>
          <li className="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Deleted</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{datasetIsDeleted}</div>
          </li>    



          <li className="flex align-items-center py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Samples</div>

              { isAnyDeletedSamples() ?
                <div className="flex justify-content text-danger" tooltip='Samples in RED have been deleted'> Samples marked with <i className='pi pi-exclamation-triangle text-danger mr-2 ml-2' /> have been deleted. </div>
                :
                null   
                }
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">

              </div>
              <div className="card">
                <DataTable value={samples} 
                    emptyMessage="Dataset currently has no Samples."
                    tableStyle={{ minWidth: '50rem' }}
                    footer={ sampleFooter }
                    selectionMode={rowClick ? null : 'checkbox'} 
                    selection={selectedSamples} 
                    onSelectionChange={(e) => setSelectedSamples(e.value)} 
                    dataKey="id" 
                >
                    { data?.isDeleted ? null : <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} ></Column> }
                    <Column field="name" header="Name" body={nameBodyTemplate}></Column>
                    <Column body={sample => sample.files[0]?.name || ''} header="File 1"></Column>
                    <Column body={sample => sample.files[1]?.name || ''} header="File 2"></Column>
                    <Column body={sample => dateTemplate(sample, 'createdAt')} header="Creation Date"></Column>
                </DataTable>
                <div className="card">
                    <PickList dataKey="id" source={source} target={target} onChange={onChange} itemTemplate={itemTemplate} filter filterBy="name" breakpoint="1280px"
                        sourceHeader="Available" targetHeader="Selected" sourceStyle={{ height: '24rem' }} targetStyle={{ height: '24rem' }}
                        sourceFilterPlaceholder="Search by name" targetFilterPlaceholder="Search by name" />
                </div>
                <div className="flex justify-content-end m-4">
                    { data_is_public ? 'Public Datasets must be updated by the Dataset owner.' : <Button label="Add Sample" onClick={() => addSamples()} /> }
                </div>
                
            </div> 
          </li>

          <li className="flex align-items-center py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Dataset Attributes</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                {/* {data.datasetattributes && data.datasetattributes.map(attribute => <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{attribute.name}: {attribute.value}</div>)}
                {(!data.datasetattributes || !data.datasetattributes.length) && <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">None</div>} */}
              </div>
              <div className="card">
                <DataTable value={attributes} 
                    emptyMessage="Dataset currently has no Attributes." 
                    tableStyle={{ minWidth: '50rem' }}
                >
                    <Column field="id" header="ID"></Column>
                    <Column field="name" header="Name"></Column>
                    <Column field="value" header="Category"></Column>
                </DataTable>

                {/* <Button label="Add Attribute" onClick={() => setAddAttribute(true)} /> */}

                {/* Add Attribute Form */}
                <div className="surface-section px-4 py-8 md:px-6 lg:px-8">
                    {/* <div className="grid"> */}
                    <div>
                        <div className="col-12 lg:col-2">
                            <div className="text-900 font-medium text-xl mb-3">Add Attribute</div>
                            <p className="m-0 p-0 text-600 line-height-3 mr-3">Use the fields below to create a Dataset Attribute Name, and Value. Click 'Create Attribute' button to add the attribute to {name}</p>
                        </div>

                        <form onSubmit={formik.handleSubmit} className="flex flex-column gap-2">
                            <div className="col-12 lg:col-10">
                                <div className="grid formgrid p-fluid">
                                    <div className="field mb-4 col-6">
                                        {/* <label htmlFor="nickname1" className="font-medium text-900">Nickname</label>
                                        <InputText id="nickname1" type="text" /> */}

                                        <label htmlFor="input_name">Attribute Name</label>
                                        <InputText
                                            id="name"
                                            name="name"
                                            value={formik.values.name}
                                            onChange={(e) => {
                                                formik.setFieldValue('name', e.target.value);
                                            }}
                                            className={classNames({ 'p-invalid': isFormFieldInvalid('name') })}
                                        />
                                    </div>
                                    <div className="field mb-4 col-6">
                                        <label htmlFor="input_value">Value</label>
                                        <InputText
                                            id="value"
                                            name="value"
                                            value={formik.values.value}
                                            onChange={(e) => {
                                                formik.setFieldValue('value', e.target.value);
                                            }}
                                            className={classNames({ 'p-invalid': isFormFieldInvalid('value') })}
                                        />
                                    </div>
                                    <div className="col-12">
                                        {getFormErrorMessage('value')}
                                        {getFormErrorMessage('name')}

                                        {data_is_public ? 'Public Datasets must be updated by the Dataset owner.' :<Button type="submit" label="Create Attribute" /> }
                                        
                                    </div>
                                </div>
                            </div> 
                        </form>
                    </div> 
                </div>
                {/* End of Add Attribute Form */}

            </div> 
          </li>

          <li className="flex align-items-center py-3 px-2 border-top-1 border-bottom-1 surface-border flex-wrap">
              <div className="text-500 w-6 md:w-2 font-medium">Groups</div>
              <div className="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">

              </div>
              <div className="card">
                <DataTable value={groups} emptyMessage="Dataset currently has no Groups." tableStyle={{ minWidth: '50rem' }}>
                    <Column field="id" header="ID"></Column>
                    <Column field="groupId" header="Group ID"></Column>
                </DataTable>
            </div> 
            
          </li>
          </>
          }                       
      </ul>
  </div>
  <DeletionDialog visible={deleteVisible} setVisible={setDeleteVisible} deleteCallback={() => deleteDataset(data.id)} type='dataset' name={data.name}/>


    { !data ? null :
        <>
        { !datasetIsDeleted ? 
            <div className="flex justify-end mt-5">
            <Button label="Undelete Dataset" onClick={() => unDeleteDataset(data.id)} disabled={!datasetIsDeleted} />
            </div> 
        :
            <div className="flex justify-end mt-5">
                <Button label="Delete Dataset" onClick={() => setDeleteVisible(true)} disabled={!datasetIsDeleted} />
            </div>
        }
        </>
    }

        </>

    );
}
export default DataSetDetails;